import './utils/patchDomForGoogleTranslate';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { SEOProvider } from './context/SEOContext';
import '@arco-design/web-react/dist/css/arco.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { captureCampaignLink } from './services/campaignLink';
import { captureCampaignStore } from './services/campaignStore';

// A campaign's link (?c=, D21) and its location (?store=, D27, G44): kept and
// taken out of the address together, in one replaceState, on whichever page
// it opens, before anything reads the address.
const withoutCampaign = captureCampaignLink(window.location.search);
const withoutStore = captureCampaignStore(withoutCampaign ?? window.location.search);
const cleaned = withoutStore ?? withoutCampaign;
if (cleaned !== null) {
  window.history.replaceState(window.history.state, document.title, window.location.pathname + cleaned + window.location.hash);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <SEOProvider>
        <App />
      </SEOProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then(registration => {
    registration.active?.addEventListener('message', () => {
      // Handle or ignore service worker messages
    });
  });
}
